// Копирайт лимитов бесплатной версии — решение основателя, в spec/08_copy.md секции нет.
// Правила и числа лимитов живут в `packages/contracts/src/domain/limits.ts`, здесь — только слова.
//
// Голос — вариант A «своя в чате» (docs/copy-variants.md) для лимита связей. Всё про лучик
// (счётчик, исчерпанный день, ошибка отправки) написано теплее и без мема — тем же решением,
// что и секция `ray` в copy/links.ts: лучик — жест разговора с близким, шутка тут читается шумом.
import { LINK_GENITIVE_FORMS, pluralizeWithCount, RAY_FORMS } from '~/shared/utils'

import type { LimitsCopy } from './types'

export const limits: LimitsCopy = {
  rays_left: ({ n }) => `Сегодня осталось ${pluralizeWithCount(n, RAY_FORMS)}`,
  rays_out: 'Лучики на сегодня закончились',
  rays_reset: ({ time }) => `Новые будут в ${time}`,
  rays_cta: 'Покорми меня — и лучики станут безлимитными',
  rays_error: ({ time }) => `Лучики на сегодня закончились. Новые будут в ${time}`,
  links_title: 'Свободных нитей больше нет',
  links_body: ({ limit }) =>
    `Больше ${pluralizeWithCount(limit, LINK_GENITIVE_FORMS)} бесплатно я не удержу. Покормишь — позовёшь кого захочешь.`,
  links_cta: 'Покормить меня 🍖',
  links_cancel: 'Пока хватит',
}
